import React, { ChangeEvent } from "react"
import { ToastContainer, toast } from "react-toastify"
import { getDioramaArtworksWithSpaceType } from "./service"
import { ArtworkFileConfirmModal } from "../../../components/modals/artworkfile-confirm.modal";

type GalleryDetail = {
    name: string;
    spaceType: string;
}

export type DioramaSpaceType = {
    id: string;
    name: string;
    galleryDetail: GalleryDetail;
}

export const ArtworkFiles = () => {
    
    React.useEffect(() => {
        (async function() {
            const dioramasResp = await getDioramaArtworksWithSpaceType();
            if (dioramasResp.status) {
                setDioramas(dioramasResp.artworks);
            }
        })()
    }, [])

    const successNotify = (msg: any) => {
        toast.success(msg, {
          position: "bottom-left",
        })
    }

    const failedNotify = (msg: string) => {
        toast.error(msg, {
            position: "bottom-left",
        })
    }

    const [ isDiorama, setIsDiorama ] = React.useState<boolean>(false);
    const [ dioramas, setDioramas ] = React.useState<DioramaSpaceType[]>([]);
    const [ selectedDiorama, setSelectedDiorama ] = React.useState<DioramaSpaceType>();

    const [ artworkType, setArtworkType ] = React.useState<string>("");
    const [ modelFile, setModelFile ] = React.useState<File>();

    const [ confirmModal, setConfirmModal ] = React.useState<boolean>(false);

    const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        setModelFile(e.target.files[0]);
    }

    const onUpdate = () => {
        if (!modelFile) {
            failedNotify("Model file is not selected")
            return;
        }

        if (isDiorama) {
            if (!selectedDiorama) {
                // error
                failedNotify("Diorama is not selected")
                return;
            }
        } else {
            if (!artworkType) {
                failedNotify("Artwork type is not selected")
                return;
            }
        }

        setConfirmModal(true);
    }

    const onSubmitted = (status: boolean) => {
        if (status) {
            successNotify("Successfully updated.");
        } else {
            failedNotify("Failed to update.")
        }
    }

    return (
        <div className="container mb-4">
            <div className="mt-5">
                <button className="btn-custom small" onClick={onUpdate}>Update</button>
            </div>
            <div className="mt-3">
                <label htmlFor="artworkfile">Select Artwork GLB</label>
                <input 
                    id="artworkfile" 
                    type="file" 
                    onChange={onFileChange} 
                    className="form-control w-50 mt-3"
                />
            </div>
            <div className="mt-4">
                <input 
                    className="me-1"
                    id="is_diorama" 
                    type="checkbox" 
                    checked={isDiorama}
                    onChange={e => setIsDiorama(e.target.checked)}
                />
                <label htmlFor="is_diorama">Is Diorama?</label>
            </div>
            {isDiorama && <div className="w-75 mt-3">
                <div>Select one of diorama: {selectedDiorama ? selectedDiorama.galleryDetail.spaceType : ""}</div>
                <table className="table table-striped mt-3">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Space Name</th>
                            <th>Space Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dioramas.map(d => {
                            return <tr
                                key={d.id}
                                onClick={() => setSelectedDiorama(d)}
                                className={selectedDiorama && selectedDiorama.id === d.id ? "active" : ""}
                            >
                                <td>{d.id}</td>
                                <td>{d.name}</td>
                                <td>{d.galleryDetail.name}</td>
                                <td>{d.galleryDetail.spaceType}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>}
            {!isDiorama && <div className="mt-2">
                Select artwork type to update model
                <div>
                    <input type="radio" id="image" name="artworkType" className="me-2" onChange={() => setArtworkType("image")}/>
                    <label htmlFor="image">Image</label>
                </div>
                <div>
                    <input type="radio" id="3dmodel" name="artworkType" className="me-2" onChange={() => setArtworkType("3dmodel")}/>
                    <label htmlFor="3dmodel">3D model</label>
                </div>
                <div>
                    <input type="radio" id="sound" name="artworkType" className="me-2" onChange={() => setArtworkType("sound")}/>
                    <label htmlFor="sound">Sound</label>
                </div>
            </div>}
            <ToastContainer />
            <ArtworkFileConfirmModal 
                artwork={selectedDiorama}
                file={modelFile}
                isDiorama={isDiorama}
                onHide={() => setConfirmModal(false)}
                show={confirmModal}
                onSubmitted={onSubmitted}
                types={artworkType}
            />
        </div>
    )
}